<template>
    <div class="mb-4">
        <b-row>
            <b-col sm="6">
                <b-card>
                    <b-row>
                        <b-col sm="6">
                            <h4 class="strong">Calculation</h4>
                        </b-col>
                        <b-col sm="6" v-if="isPwfOk != null" style="text-align: end">
                            <b-badge v-if="isPwfOk" variant="success">OK. Pwf is greater than Pb.</b-badge>
                            <b-badge v-else variant="warning">Warning! Pwf is lesser than Pb!</b-badge>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col md="6">
                            <b-row>
                                <b-col sm="12">
                                    <b-form-text>Pwf@Qdes</b-form-text>
                                </b-col>
                                <b-col sm="12">
                                    <strong>{{ pwfQdes }} </strong> <span style="font-size: 10pt"> psi</span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3" v-for="data in data2" v-bind:key="data[0]">
                                <b-col sm="12">
                                    <b-form-text>{{ data[0] }}</b-form-text>
                                </b-col>
                                <b-col sm="12">
                                    <strong>{{ data[1] }}</strong> <span style="font-size: 10pt"> {{ data[2] }}</span>
                                </b-col>
                                <!-- <label :title="data[0]" class="col-sm-4 col-form-label single-line">{{ data[0] }}</label>
                                <label class="col-sm-4 col-form-label" style="text-align: right"><strong>{{ data[1] }}</strong></label>
                                <label class="col-sm-4 col-form-label single-line" style="padding-left: 0px">{{ data[2] }}</label> -->
                            </b-row>
                        </b-col>
                        <b-col md="6">
                            <b-row>
                                <b-col sm="12">
                                    <b-form-text>Qdes</b-form-text>
                                </b-col>
                                <b-col sm="12">
                                    <strong>{{ qDes }}</strong> <span style="font-size: 10pt"> BPD</span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3" v-for="data in data1" v-bind:key="data[0]">
                                <b-col sm="12">
                                    <b-form-text>{{ data[0] }}</b-form-text>
                                </b-col>
                                <b-col sm="12">
                                    <strong>{{ data[1] }}</strong> <span style="font-size: 10pt"> {{ data[2] }}</span>
                                </b-col>
                                <!-- <label :title="data[0]" class="col-sm-4 col-form-label single-line">{{ data[0] }}</label>
                                <label class="col-sm-4 col-form-label" style="text-align: right"><strong>{{ data[1] }}</strong></label>
                                <label class="col-sm-4 col-form-label single-line" style="padding-left: 0px">{{ data[2] }}</label> -->
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col sm="6">
                <b-card>
                    <h4 class="strong">Inflow Performance Relationship</h4>
                    <hr />
                    <scatter-chart :chartData="chartData" :options="chartOptions"></scatter-chart>
                    <div class="mt-4" style="text-align: right">
                        <b-btn variant="primary" v-b-modal.modal-chart>
                            Attach Chart&ensp;<font-awesome-icon icon="file-download" />
                        </b-btn>
                    </div>
                </b-card>
            </b-col>
            <b-modal size="xl" id="modal-chart" title="Attaching Chart to Summary"
                ok-title="Attach"
                :ok-disabled="isAttaching"
                :cancel-disabled="isAttaching"
                :no-close-on-esc="isAttaching"
                :hide-header-close="isAttaching"
                no-close-on-backdrop
                @ok="attachIPRChart">
                <div style="text-align: center">
                    <scatter-chart chart-id="finalChart" :chartData="chartData" :options="chartOptions" style="height: 400px !important; width: 581px !important"></scatter-chart>
                </div>
                <br />
                The chart image above will be attached into your summary report.
            </b-modal>
        </b-row>
    </div>
</template>

<script>
import ScatterChart from '../components/ScatterChart'

export default {
    components: {
        ScatterChart
    },
    name: 'ipr-curve',
    data() {
        return {

            pwfQdes: 0,
            qDes: 0,
            data1: [],
            data2: [],
            isPwfOk: null,

            // Charts
            chartData: {},
            chartOptions: {},
            isAttaching: false

        }
    },
    created: function() {

        this.$router.app.$emit("changeTab", "ipr-curve")

        // List of output keys that should be converted to respective unit.
        let meteredKeys = ["WFL", "WHP", "CP", "FrictionLoss", "TDH2", "FluidOverPump", "FluidGradient"]

        this.qDes = this.$core.input.qDes

        let output = JSON.parse(JSON.stringify(this.$core.output))
        let unit = this.$core.general.unit

        for(let [key, value] of Object.entries(output)) {
            var val = value

            // Transform value into meter if the unit selected is meter
            if(unit == "m" && meteredKeys.includes(key)) {
                val = value / 3.281
            }

            output[key] = this.$helper.roundify(val)
        }

        this.pwfQdes = output.PwfQdes

        this.data1.push(["PSD", this.$helper.roundify(this.$core.input.psd), `${unit} TVD`])
        this.data1.push(["Qmax", output.qmax, "BPD"])
        this.data1.push(["SG Fluid", output.SGFluid, ""])
        this.data1.push(["PIP", output.PIP, "psi"])
        this.data1.push(["% Free Gas", output.PrctFG, "%"])

        if(this.$core.general.instrument == "Sonolog") {
            this.data1.push(["SFL", this.$core.input.sfl, `${unit}`])
            this.data1.push(["DFL", this.$core.input.dfl, `${unit}`])
        }
        else {
            this.data1.push(["SBHP", this.$core.input.sbhp, "psig"])
            this.data1.push(["FBHP", this.$core.input.fbhp, "psig"])
        }

        if(this.$core.general.method == "Straight Line") {
            this.data1.push(["PI", output.PI, "BPD / psi"])
        }

        this.data2.push(["Composite SG", output.CompositeSG, ""])
        this.data2.push(["WFL", output.WFL, `${unit} TVD`])
        this.data2.push(["WHP", output.WHP, `${unit} TVD`])
        this.data2.push(["P. Casing", output.CP, `${unit} TVD`])
        this.data2.push(["Friction Loss", output.FrictionLoss, `${unit} TVD`])
        this.data2.push(["TDH", output.TDH2, `${unit} TVD`])
        this.data2.push(["Fluid Over Pump", output.FluidOverPump, `${unit} TVD`])
        this.data2.push(["Fluid Gradient", output.FluidGradient, `psi / ${unit} TVD`])

        if(this.$core.input.pb != null && this.$core.input.pb != "") {
            this.isPwfOk = Number(this.$core.input.pb) < Number(output.PwfQdes)
        }

        // Chart data and options
        let that = this

        this.chartOptions = {
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Flow Rate, Q (BFPD)'
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: that.$core.general.instrument == "Downhole Sensor" ? "Pressure (psi)" : `Head (${that.$core.general.unit} TVD)`
                    },
                    ticks: {
                        // suggestedMin: -6555,
                        // min: -6555,
                        beginAtZero: that.$core.general.instrument == "Downhole Sensor",
                        userCallback: function(label, index, labels) {
                            if(that.$core.general.instrument == "Downhole Sensor") {
                                return label
                            }
                            else {
                                return label * -1
                            }
                        }
                    }
                }]
            },
            legend: {
                display: true
            },
            title: {
                display: false
            },
            // onAnimationComplete: this.triggerAnimationDone()
        }

        // Chart Data population
        if(this.$core.general.method == "Straight Line") {
            this.setupStraightLineChart(output)
        }
        else {
            this.setupVogelChart(output)
        }

    },
    methods: {

        attachIPRChart(modal) {
            modal.preventDefault();

            let c = document.getElementById('finalChart')
            var ctx = c.getContext("2d")
            ctx.globalCompositeOperation = 'destination-over'
            ctx.fillStyle = "white"
            ctx.fillRect(0, 0, 581, 400)

            let calcName = this.$core.general.name

            var that = this
            that.isAttaching = true
            setTimeout(function() {

                let canvas = c.toDataURL('image/jpeg', 0.6)

                let payload = {
                    id: that.$core.id,
                    base64: canvas
                }

                that.$axios.post("/calc/attachIPR", payload).then(response => {

                    let res = response.data
                    if(res.message == "OK") {
                        that.$core.attachment.ipr = true
                        that.$helper.toastSuccess(that, "Chart successfully attached.")
                        that.$bvModal.hide('modal-chart')
                    }
                    else {
                        that.$helper.toastError(that, res.message)
                    }

                })
                .catch(error => {
                    that.$helper.toastError(that, error)
                })
                .finally(() => {
                    that.isAttaching = false
                })

            }, 1000)

        },

        setupStraightLineChart(output) {

            this.chartData = {
                datasets: [
                    {
                        backgroundColor: '#f87979', borderColor: '#f87979',
                        borderDash: [5, 5], lineTension: 0.5, borderWidth: 2,
                        showLine: true, fill: false, label: 'IPR Straight Line',
                        data: output.iprChart1
                    },
                    {
                        backgroundColor: '#757dd9', borderColor: '#757dd9',
                        borderDash: [5, 5], lineTension: 0, borderWidth: 2,
                        showLine: true, fill: false, label: '@ PSD',
                        data: output.iprChart2
                    },
                    {
                        backgroundColor: '#388e3c', borderColor: '#388e3c',
                        borderDash: [5, 5], lineTension: 0, borderWidth: 2,
                        showLine: true, fill: false, label: '@ Qdes',
                        data: output.iprChart3
                    }
                ]
            }

        },

        setupVogelChart(output) {

            this.chartData = {
                datasets: [
                    {
                        backgroundColor: '#f87979', borderColor: '#f87979',
                        borderDash: [5, 5], lineTension: 0.5, borderWidth: 2,
                        showLine: true, fill: false, label: 'IPR Vogel',
                        data: output.iprChart1
                    },
                    {
                        backgroundColor: '#757dd9', borderColor: '#757dd9',
                        borderDash: [5, 5], lineTension: 0, borderWidth: 2,
                        showLine: true, fill: false, label: '@ PSD',
                        data: output.iprChart2
                    },
                    {
                        backgroundColor: '#388e3c', borderColor: '#388e3c',
                        borderDash: [5, 5], lineTension: 0, borderWidth: 2,
                        showLine: true, fill: false, label: '@ Qdes',
                        data: output.iprChart3
                    }
                ]
            }

        }

    }
}
</script>

<style>
    .single-line {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>